import React, { useState, useEffect, useRef, useContext } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { useParams } from 'react-router-dom';

import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
// MUI Modal
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { AuthContext } from '../../context/AuthContext';
import SecurityHeaders from '../../data/SecurityHeaders';
import {
    EmailIcon,
    EmailShareButton,

    LinkedinIcon,
    LinkedinShareButton,


    TelegramIcon,


    TelegramShareButton,

    TwitterIcon,

    TwitterShareButton,

    WhatsappIcon,

    WhatsappShareButton,

} from "react-share";
import ModalStyle from '../../data/ModalStyle';
import { Share } from '@material-ui/icons';
const FileUpload = ({ onFileSelect, selectedFile, showSnackbar }) => {
    const fileInputRef = useRef(null);

    const handleFileClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && (file.type === "application/zip" || file.type === "application/x-zip-compressed")) {
            onFileSelect(file);
        } else {
            showSnackbar("Please select a .ZIP file.", "warning");
            onFileSelect(null);
        }
    };

    return (
        <FileUploadContainer onClick={handleFileClick}>
            <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                className="d-none"
                accept=".zip"
            />
            <div className="d-flex flex-column align-items-center">
                <UploadCloudIcon />
                {selectedFile ? (
                    <p className="mt-2 text-secondary">File: <span className="fw-semibold">{selectedFile.name}</span></p>
                ) : (
                    <>
                        <p className="mt-2 text-secondary">Drag & drop your file here, or click to browse.</p>
                        <p className="text-xs text-secondary mt-1">Please upload a single ZIP file.</p>
                    </>
                )}
            </div>
        </FileUploadContainer>
    );
};
const muiModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
    outline: 'none',
    maxWidth: '95vw'
};

const MalwareAssignmentItem = ({ challenge }) => {
    const { user } = useContext(AuthContext);
    const [timeLeft, setTimeLeft] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [share, setshare] = useState(false);
    const currenturl = 'https://skillsuprise.com/hacking-challenge/' + (challenge && challenge.challenge_id ? challenge.challenge_id : '');

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'info',
    });

    const showSnackbar = (message, severity = 'info') => {
        setSnackbar({ open: true, message, severity });
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setSnackbar({ ...snackbar, open: false });
    };

    useEffect(() => {
        if (!challenge) return;

        const submissionDeadline = new Date(challenge.submission_deadline);

        const calculateTimeLeft = () => {
            const difference = +submissionDeadline - +new Date();
            let timeLeft = {};
            if (difference > 0) {
                timeLeft = {
                    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                    hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                    minutes: Math.floor((difference / 1000 / 60) % 60),
                    seconds: Math.floor((difference / 1000) % 60),
                };
            }
            return timeLeft;
        };

        setTimeLeft(calculateTimeLeft());
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, [challenge]);

    const formatTime = (time) => String(time).padStart(2, '0');
    const isTimeUp = Object.keys(timeLeft).length === 0;

    useEffect(() => {
        // debug only when selectedFile changes
        // console.log('selectedFile changed', selectedFile);
    }, [selectedFile]);

    const handleFinalSubmit = async () => {
        if (!selectedFile) {
            showSnackbar("Please select a file to submit.", "warning");
            return;
        }
        if (!challenge || !challenge.challenge_id) {
            showSnackbar("Challenge ID missing.", "error");
            return;
        }
        if (!user) {
            window.location.replace('/login');
            showSnackbar("User not logged in.", "error");
            return;
        }

        // more robust ZIP check: mime OR .zip extension
        const name = selectedFile.name || "";
        const mime = selectedFile.type || "";
        const isZip = mime.includes('zip') || name.toLowerCase().endsWith('.zip');
        if (!isZip) {
            showSnackbar("Only ZIP files are allowed.", "warning");
            return;
        }

        setLoading(true);

        const formData = new FormData();
        formData.append('challenge_id', challenge && challenge.challenge_id ? challenge.challenge_id : '');
        formData.append('session', user.SessionId);
        formData.append('file', selectedFile);

        try {
            const response = await axios.post(
                'https://skillsuprise.com/hacking-challenge-file-submission.php',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            if (response.data.status === 'success') {
                showSnackbar('File uploaded successfully!', 'success');
                setIsModalOpen(false);
                setSelectedFile(null);
            } else {
                showSnackbar(response.data.message || 'Failed to upload file.', 'error');
            }
        } catch (err) {
            showSnackbar('Error uploading file.', 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <CardContainer className="container my-4">
                <div className="row g-4 ">
                    {/* Left Column */}
                    <div className="col-lg-7">
                        <div className="d-flex align-items-center gap-3 mb-3">
                            <h1 className="h3 fw-bold text-dark">{challenge.title}</h1>
                        </div>


                        <div className="d-flex flex-wrap gap-3 text-secondary mb-4">
                            <div className="d-flex align-items-center">
                                <RupeeIcon /> <strong>Prize Money:</strong><span className="ms-2">₹{challenge.prize_money}</span>
                            </div>
                            <div className="d-flex align-items-center">
                                <CalendarIcon /> <strong>Deadline:</strong><span className="ms-2">{new Date(challenge.submission_deadline).toLocaleDateString()}</span>
                            </div>
                            <div className="d-flex align-items-center">
                                <ClockIcon /> <strong>Time Remaining:</strong>
                                <TimeDisplay className="ms-2 text-danger ">
                                    {isTimeUp ? "Time's up!" : `${formatTime(timeLeft.days)}d ${formatTime(timeLeft.hours)}h ${formatTime(timeLeft.minutes)}m ${formatTime(timeLeft.seconds)}s`}
                                </TimeDisplay>
                            </div>
                        </div>

                        <hr className="my-4" />
                        <h5>About Assignment</h5>
                        <p className="p text-secondary mb-4">{challenge.description}</p>

                        <div className="mb-4">
                            <h3 className="h6 fw-semibold text-dark mb-3">Skills Required</h3>
                            <div className="d-flex flex-wrap gap-2">
                                {challenge.skills_required.map((skill, index) => (
                                    <Badge key={index}>{skill}</Badge>
                                ))}
                            </div>
                        </div>

                        <div>
                            <h2 className="h5 fw-semibold text-dark mb-3">Instructions</h2>
                            <ul className="list-group list-group-flush">
                                {challenge.instructions.map((instruction, index) => (
                                    <li key={index} className="list-group-item text-secondary">{instruction}</li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    {/* Right Column */}
                    <div className="col-lg-5">
                        <div className="card border-light">
                            <div className="card-body" style={{ textAlign: 'left' }}>
                                <h2 className="h5 fw-semibold text-dark mb-3">Submission Process</h2>
                                <ol className="list-group list-group-numbered list-group-flush mb-4">
                                    {challenge.submission_process.map((step, index) => (
                                        <li key={index} className="list-group-item text-secondary">{step}</li>
                                    ))}
                                </ol>

                             

                                <div className="d-flex flex-column gap-2 mt-4">
                                    <Link to={'/hacking-challenge-leaderboard/' + (challenge && challenge.challenge_id ? challenge.challenge_id : '')} className="btn btn-primary text-white fw-bold">Top Performers</Link>
                                    <SubmitButton
                                        disabled={isTimeUp}
                                        onClick={() => user ? setIsModalOpen(true) : window.location.replace('/login')}
                                    >
                                        {isTimeUp ? 'Submission Closed' : 'Submit Assignment'}
                                    </SubmitButton>
                                </div>

                                <hr className="my-4" />

                                <div>
                                    <div>
                                        <h3 className="h6 fw-semibold text-dark mb-3">Assignment Overview</h3>
                                       <div className="">
                                    
                                        <div className="d-flex align-items-center mb-2">
                                            <h6 type='button' onClick={() => setshare(true)} className="ms-2 "> <Share /> Share Assignment </h6>
                                        </div></div>
                                        {/* Copy URL button/link */}
                                        <div className="d-flex align-items-center ">

                                            <p
                                                type="button"
                                                className="text-info text-decoration-underline d-flex align-items-center"
                                                onClick={async (e) => {
                                                    e.preventDefault();
                                                    try {
                                                        if (navigator.clipboard && navigator.clipboard.writeText) {
                                                            await navigator.clipboard.writeText(currenturl);
                                                        } else {
                                                            // fallback
                                                            const ta = document.createElement('textarea');
                                                            ta.value = currenturl;
                                                            ta.style.position = 'fixed';
                                                            ta.style.left = '-9999px';
                                                            document.body.appendChild(ta);
                                                            ta.select();
                                                            document.execCommand('copy');
                                                            document.body.removeChild(ta);
                                                        }
                                                        showSnackbar('URL copied to clipboard', 'success');
                                                    } catch (err) {
                                                        showSnackbar('Failed to copy URL', 'error');
                                                    }
                                                }}
                                            >
                                                <LinkIcon /> <span className="me-2">{currenturl}</span>
                                            </p>


                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </CardContainer>
            {/* MUI Modal for file upload */}
            <Modal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={muiModalStyle}>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h2 className="h5 fw-bold text-dark mb-0">Submit Your Assignment</h2>
                        <IconButton onClick={() => setIsModalOpen(false)} size="small">
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <FileUpload onFileSelect={setSelectedFile} selectedFile={selectedFile} showSnackbar={showSnackbar} />
                    <div className="d-flex justify-content-end gap-2 mt-4">
                        <button
                            onClick={() => setIsModalOpen(false)}
                            className="btn btn-secondary"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleFinalSubmit}
                            className="btn btn-success"
                            disabled={!selectedFile || loading}
                        >
                            {loading ? "Uploading..." : "Submit"}
                        </button>
                    </div>
                </Box>
            </Modal>

            {/* Snackbar for feedback */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <MuiAlert
                    onClose={handleSnackbarClose}
                    severity={snackbar.severity}
                    sx={{ width: '100%' }}
                    elevation={6}
                    variant="filled"
                >
                    {snackbar.message}
                </MuiAlert>
            </Snackbar>
            <Modal
                open={share}
                onClose={() => setshare(false)}

            >
                <Box sx={ModalStyle} className="p-3 col-lg-3 col-md-3 col-sm-4 col-12">
                    <div className="modal-header">
                        <h4 className="mb-0">Share this video</h4>
                        <CloseIcon onClick={() => setshare(false)} className="click" />
                    </div>

                    <div className="modal-body d-flex justify-content-center align-items-center  mt-3">
                        <WhatsappShareButton size={30} round={true} url={currenturl}><WhatsappIcon size={30} type="button" round={true} url={currenturl} className="mr-2" /></WhatsappShareButton>
                        <LinkedinShareButton size={30} round={true} url={currenturl}><LinkedinIcon size={30} type="button" round={true} url={currenturl} className="mr-2"></LinkedinIcon></LinkedinShareButton>
                        <TelegramShareButton size={30} round={true} url={currenturl}><TelegramIcon size={30} type="button" round={true} url={currenturl} className="mr-2" /></TelegramShareButton>
                        <TwitterShareButton size={30} round={true} url={currenturl}><TwitterIcon size={30} type="button" round={true} url={currenturl} className="mr-2" /></TwitterShareButton>
                        <EmailShareButton size={30} round={true} url={currenturl}><EmailIcon size={30} type="button" round={true} url={currenturl} className="mr-2" /></EmailShareButton>


                    </div>
                </Box>
            </Modal>
        </>
    )
}

export default MalwareAssignmentItem
// --- SVG Icons for the UI ---
const RupeeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-2 text-secondary">
        <path d="M6 3h12a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4z"></path>
        <path d="M8 8h8"></path><path d="M8 12h8"></path>
        <path d="M11 16h2"></path>
    </svg>
);

const CalendarIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-2 text-secondary">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
        <line x1="16" y1="2" x2="16" y2="6"></line>
        <line x1="8" y1="2" x2="8" y2="6"></line>
        <line x1="3" y1="10" x2="21" y2="10"></line>
    </svg>
);

const ClockIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-2 text-secondary">
        <circle cx="12" cy="12" r="10"></circle>
        <polyline points="12 6 12 12 16 14"></polyline>
    </svg>
);

const InfoIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-danger me-3 flex-shrink-0">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="16" x2="12" y2="12"></line>
        <line x1="12" y1="8" x2="12.01" y2="8"></line>
    </svg>
);

const LinkIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-2">
        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.72"></path>
        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.72-1.72"></path>
    </svg>
);

const UploadCloudIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="text-secondary">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
        <polyline points="17 8 12 3 7 8"></polyline>
        <line x1="12" y1="3" x2="12" y2="15"></line>
    </svg>
);

// --- Styled Components for Custom Styling ---

const CardContainer = styled.div`
    width: 100%;
    background-color: #fff;
    border-radius: 0.5rem;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    border: 1px solid #dee2e6;
    padding: 1.5rem;
    @media (min-width: 768px) {
        padding: 2.5rem;
    }
`;
const FileUploadContainer = styled.div`
    border: 2px dashed #ced4da;
    border-radius: 0.5rem;
    padding: 2rem;
    text-align: center;
    cursor: pointer;
    transition: border-color 0.3s;
    &:hover {
        border-color: #0dcaf0;
    }
`;

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1050;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
`;

const ModalContent = styled.div`
    background-color: #fff;
    border-radius: 0.5rem;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    width: 100%;
    max-width: 500px;
    position: relative;
    padding: 1.5rem;
`;

const CloseButton = styled.button`
    position: absolute;
    top: 1rem;
    right: 1rem;
    font-size: 1.5rem;
    color: #6c757d;
    background: none;
    border: none;
    &:hover {
        color: #343a40;
    }
`;

const Badge = styled.span`
    background-color: #e0f7fa;
    color: #0dcaf0;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 0.25rem 0.75rem;
    border-radius: 9999px;
`;

const TimeDisplay = styled.span`
    background-color: #f8f9fa;
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;
    font-family: monospace;

`;

const SubmitButton = styled.button`
    background-color: ${props => props.disabled ? '#ced4da' : '#28a745'};
    color: ${props => props.disabled ? '#6c757d' : '#fff'};
    font-weight: bold;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;
    border: none;
    width: 100%;
    transition: background-color 0.3s;
    &:hover {
        background-color: ${props => props.disabled ? '#ced4da' : '#218838'};
    }
`;